export enum QueryKeys {
  Leaderboard = "leaderboard",
}
